import { message, PageHeader, Spin, Upload, Row, Col, Radio, Table, Checkbox, Select, InputNumber, Switch, Tag, Alert, Divider } from "antd";
import { FileZipOutlined, UploadOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
    Form,
    FormItem,
    ButtonItem,
    ErrorItem,
} from "../../../Components/Items";
import SelectEmpresasBiwoItem from "../../../Components/SelectEmpresasBiwoItem";
import SeleccionarZipDescargaSat from "../../../Components/SeleccionarZipDescargaSat";
import ModalProgreso from "../../../Components/ModalProgreso";
import SeguidorProcesoMasivo from "../../../Components/seguirProcesoMasivo";

const { Option } = Select;

// RFC persona moral: 3 letras + 6 dígitos + 3 homoclave = 12 caracteres.
// RFC persona física: 4 letras + 6 dígitos + 3 homoclave = 13 caracteres.
const esPersonaMoralPorRfc = (rfc) => (rfc || "").length === 12;

// El CFDI solo trae un nombre completo; se separa con la convención Nombre(s) + Apellido Paterno + Apellido Materno.
const dividirNombreCompleto = (nombreCompleto) => {
    const partes = (nombreCompleto || "").trim().split(/\s+/).filter(Boolean);
    if (partes.length === 0) return { nombre: undefined, apellidoPaterno: undefined, apellidoMaterno: undefined };
    if (partes.length === 1) return { nombre: partes[0], apellidoPaterno: undefined, apellidoMaterno: undefined };
    if (partes.length === 2) return { nombre: partes[0], apellidoPaterno: partes[1], apellidoMaterno: undefined };
    return {
        nombre: partes.slice(0, partes.length - 2).join(" "),
        apellidoPaterno: partes[partes.length - 2],
        apellidoMaterno: partes[partes.length - 1],
    };
};

class ImportarSatEntidades extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        empresaId: null,
        tipo: "emision",
        origenZip: "subir",
        archivoZip: [],
        zipExistenteRef: null,
        leido: false,
        clientes: [],
        proveedores: [],
        insumos: [],
        usosDeCFDI: [],
        catalogosInsumos: { familias: [], unidades: [], marcas: [], tiposDeInsumo: [] },
        importandoInsumos: false,
        progreso: { procesados: 0, total: null },
    };

    atras() {
        this.props.history.goBack();
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onChangeEmpresa(empresaId) {
        this.setState({ empresaId, leido: false });
    }

    onChangeTipo(e) {
        this.setState({
            tipo: e.target.value,
            leido: false,
            clientes: [],
            proveedores: [],
            insumos: [],
        });
    }

    onChangeOrigenZip(e) {
        this.setState({ origenZip: e.target.value, archivoZip: [], zipExistenteRef: null });
    }

    onChangeZip(file) {
        if (file.name?.toLowerCase().endsWith(".zip")) {
            this.setState({ archivoZip: [{ ...file, status: "done", originFileObj: file }] });
        } else {
            message.error("El archivo debe ser un ZIP");
        }
    }

    leerXml() {
        if (!this.state.empresaId) {
            message.error("Selecciona una empresa");
            return;
        }
        if (this.state.origenZip === "subir" && this.state.archivoZip.length === 0) {
            message.error("Sube un archivo ZIP");
            return;
        }
        if (this.state.origenZip === "existente" && !this.state.zipExistenteRef) {
            message.error("Elige un ZIP ya descargado");
            return;
        }

        this.setState({ loading: true });
        const emision = this.state.tipo === "emision";

        let peticion;
        if (this.state.origenZip === "subir") {
            const formData = new FormData();
            formData.append("empresaId", this.state.empresaId);
            formData.append("emision", emision);
            formData.append("zip", this.state.archivoZip[0].originFileObj);
            peticion = axios.post("importarSatEntidades/proponerEntidades", formData, {
                headers: { ...this.props.headersToken, "Content-Type": "multipart/form-data" },
            });
        } else {
            peticion = axios.post(
                "importarSatEntidades/proponerEntidades",
                {
                    empresaId: this.state.empresaId,
                    emision,
                    zipExistenteRef: this.state.zipExistenteRef,
                },
                { headers: this.props.headersToken }
            );
        }

        peticion
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    if (emision) {
                        this.setState({
                            leido: true,
                            clientes: (res.data.clientes || []).map((c) => ({
                                ...c,
                                key: c.rfc,
                                seleccionado: !c.yaExiste,
                            })),
                            insumos: (res.data.insumos || []).map((i, index) => ({
                                ...i,
                                key: `${i.clave}-${index}`,
                                seleccionado: !i.yaExiste,
                                familiaId: undefined,
                                inventariable: false,
                                venta: true,
                                compra: false,
                            })),
                            catalogosInsumos: res.data.catalogosInsumos || {},
                            usosDeCFDI: res.data.usosDeCFDI || [],
                            proveedores: [],
                        });
                    } else {
                        this.setState({
                            leido: true,
                            proveedores: (res.data.proveedores || []).map((p) => ({
                                ...p,
                                key: p.rfc,
                                seleccionado: !p.yaExiste,
                            })),
                            clientes: [],
                            insumos: [],
                        });
                    }
                } else {
                    message.error(res.data.mensaje || "No se pudieron leer los XMLs");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Hubo un error al leer los XMLs");
            });
    }

    toggleSeleccion(coleccion, key) {
        this.setState((prevState) => ({
            [coleccion]: prevState[coleccion].map((row) =>
                row.key === key ? { ...row, seleccionado: !row.seleccionado } : row
            ),
        }));
    }

    actualizarCampoInsumo(key, campo, valor) {
        this.setState((prevState) => ({
            insumos: prevState.insumos.map((row) => (row.key === key ? { ...row, [campo]: valor } : row)),
        }));
    }

    actualizarCampoCliente(key, campo, valor) {
        this.setState((prevState) => ({
            clientes: prevState.clientes.map((row) => (row.key === key ? { ...row, [campo]: valor } : row)),
        }));
    }

    construirPayloadCliente(row) {
        const rfc = row.rfc || "";
        const persona = esPersonaMoralPorRfc(rfc); // true = persona moral (razonSocial); false = persona física (nombre + apellidos)
        const { nombre, apellidoPaterno, apellidoMaterno } = persona
            ? { nombre: undefined, apellidoPaterno: undefined, apellidoMaterno: undefined }
            : dividirNombreCompleto(row.nombre);
        const usoCatalogo = (this.state.usosDeCFDI || []).find((u) => u._id === row.usoDeCFDIId);
        return {
            codigo: rfc,
            rfc,
            persona,
            razonSocial: persona ? row.nombre : undefined,
            nombre,
            apellidoPaterno,
            apellidoMaterno,
            usoDeCFDI: usoCatalogo ? usoCatalogo.c_UsoCFDI : row.usoDeCFDI || undefined,
            regimenFiscal: row.regimenFiscal ? String(row.regimenFiscal) : undefined,
        };
    }

    construirPayloadProveedor(row) {
        const rfc = row.rfc || "";
        const persona = esPersonaMoralPorRfc(rfc); // true = persona moral (razonSocial); false = persona física (nombre + apellidos)
        const { nombre, apellidoPaterno, apellidoMaterno } = persona
            ? { nombre: undefined, apellidoPaterno: undefined, apellidoMaterno: undefined }
            : dividirNombreCompleto(row.nombre);
        return {
            codigo: rfc,
            rfc,
            persona,
            razonSocial: persona ? row.nombre : undefined,
            nombre,
            apellidoPaterno,
            apellidoMaterno,
            // El XML no trae tipo de operación/tercero: se usan valores genéricos,
            // editables después desde el catálogo de Proveedores.
            tipoOperacion: 85,
            tipoTercero: 4,
        };
    }

    construirPayloadInsumo(row) {
        return {
            clave: row.clave,
            descripcion: row.descripcion,
            descripcionLarga: row.descripcion,
            unidadId: row.unidadId,
            costo: row.costo || 0,
            familiaId: row.familiaId,
            venta: row.venta,
            compra: row.compra,
            inventariable: row.inventariable,
            impuestos: [],
            retenciones: [],
        };
    }

    componentWillUnmount() {
        if (this.seguidor) this.seguidor.detener();
    }

    /**
     * Deja el seguidor escuchando ANTES de disparar la importación. Tiene que ser
     * antes: una importación corta puede terminar entre la petición y su
     * respuesta, y si el listener todavía no existe ese "fin" se pierde.
     *
     * Ojo: esta pantalla vive en PanelPrincipal, no en Panel, así que el
     * WebSocket puede no estar abierto aquí — en ese caso el que hace el trabajo
     * es el respaldo por polling del seguidor.
     */
    prepararSeguidorInsumos() {
        if (this.seguidor) this.seguidor.detener();

        this.seguidor = new SeguidorProcesoMasivo({
            // La empresa la elige el usuario en esta pantalla; no viene de Redux.
            empresaId: this.state.empresaId,
            headersToken: this.props.headersToken,
            onProgreso: (progreso) => this.setState({ importandoInsumos: true, progreso }),
            onFin: (resumen) => {
                this.setState({ loading: false, importandoInsumos: false, progreso: { procesados: 0, total: null } });
                // Sin resumen el proceso terminó pero no dejó rastro (murió, o
                // caducó su resultado): mejor no afirmar que se completó.
                if (resumen) message.success("Importación completada");
                this.atras();
            },
            onError: (error) => {
                this.setState({ loading: false, importandoInsumos: false, progreso: { procesados: 0, total: null } });
                message.error(error || "Hubo un error al importar");
            },
        });
        this.seguidor.escuchar();
    }

    /** Ya arrancó: se le dice al seguidor qué corrida seguir y se abre el modal. */
    seguirImportacionInsumos(procesoId, total) {
        this.seguidor.seguir(procesoId);
        this.setState({ importandoInsumos: true, progreso: { procesados: 0, total } });
    }

    importarSeleccionados() {
        const emision = this.state.tipo === "emision";

        if (emision) {
            const clientesSeleccionados = this.state.clientes.filter((c) => c.seleccionado && !c.yaExiste);
            const insumosSeleccionados = this.state.insumos.filter((i) => i.seleccionado && !i.yaExiste);

            const insumosSinFamiliaOUnidad = insumosSeleccionados.filter((i) => !i.familiaId || !i.unidadId);
            if (insumosSinFamiliaOUnidad.length > 0) {
                message.error("Todos los insumos seleccionados necesitan Familia y Unidad");
                return;
            }

            if (clientesSeleccionados.length === 0 && insumosSeleccionados.length === 0) {
                message.error("No hay nada seleccionado para importar");
                return;
            }

            this.setState({ loading: true });
            const peticiones = [];
            if (clientesSeleccionados.length > 0) {
                peticiones.push(
                    axios.post(
                        "clientes/importarClientes",
                        { empresaId: this.state.empresaId, data: clientesSeleccionados.map((c) => this.construirPayloadCliente(c)) },
                        { headers: this.props.headersToken }
                    )
                );
            }
            if (insumosSeleccionados.length > 0) {
                // Antes de disparar: ver prepararSeguidorInsumos.
                this.prepararSeguidorInsumos();
                peticiones.push(
                    axios.post(
                        "insumos/importarInsumos",
                        { empresaId: this.state.empresaId, data: insumosSeleccionados.map((i) => this.construirPayloadInsumo(i)) },
                        { headers: this.props.headersToken }
                    )
                );
            }

            // importarInsumos ya no espera a terminar: responde en cuanto arranca
            // y el trabajo sigue en el servidor, escribiendo por lotes. Por eso
            // el "Importación completada" no puede colgarse del Promise.all —
            // saldría al segundo 1, con la importación apenas empezando.
            const hayInsumos = insumosSeleccionados.length > 0;

            Promise.all(peticiones)
                .then((respuestas) => {
                    if (!hayInsumos) {
                        this.setState({ loading: false });
                        message.success("Importación completada");
                        this.atras();
                        return;
                    }

                    // La respuesta de insumos es la última que se empujó.
                    const resInsumos = respuestas[respuestas.length - 1];
                    if (resInsumos?.data?.success !== 2) {
                        this.setState({ loading: false });
                        message.error(resInsumos?.data?.message || "Hubo un error al importar");
                        return;
                    }

                    this.seguirImportacionInsumos(resInsumos.data.procesoId, resInsumos.data.total ?? null);
                })
                .catch(() => {
                    this.setState({ loading: false });
                    message.error("Hubo un error al importar");
                });
        } else {
            const proveedoresSeleccionados = this.state.proveedores.filter((p) => p.seleccionado && !p.yaExiste);
            if (proveedoresSeleccionados.length === 0) {
                message.error("No hay nada seleccionado para importar");
                return;
            }

            this.setState({ loading: true });
            axios
                .post(
                    "proveedores/importarProveedores",
                    { empresaId: this.state.empresaId, data: proveedoresSeleccionados.map((p) => this.construirPayloadProveedor(p)) },
                    { headers: this.props.headersToken }
                )
                .then(() => {
                    this.setState({ loading: false });
                    message.success("Importación completada");
                    this.atras();
                })
                .catch(() => {
                    this.setState({ loading: false });
                    message.error("Hubo un error al importar");
                });
        }
    }

    renderTablaClientes() {
        const columns = [
            {
                title: "Importar",
                key: "seleccionado",
                width: 90,
                render: (_, row) => (
                    <Checkbox
                        checked={row.seleccionado}
                        disabled={row.yaExiste}
                        onChange={() => this.toggleSeleccion("clientes", row.key)}
                    />
                ),
            },
            { title: "RFC", dataIndex: "rfc", key: "rfc" },
            { title: "Nombre / Razón Social", dataIndex: "nombre", key: "nombre" },
            {
                title: "Uso de CFDI",
                key: "usoDeCFDIId",
                width: 220,
                render: (_, row) => (
                    <Select
                        style={{ width: "100%" }}
                        placeholder={row.usoDeCFDI || "Elegir"}
                        value={row.usoDeCFDIId || undefined}
                        onChange={(valor) => this.actualizarCampoCliente(row.key, "usoDeCFDIId", valor)}
                    >
                        {(this.state.usosDeCFDI || []).map((u) => (
                            <Option key={u._id} value={u._id}>{u.c_UsoCFDI} — {u.descripcion}</Option>
                        ))}
                    </Select>
                ),
            },
            { title: "Régimen Fiscal", dataIndex: "regimenFiscal", key: "regimenFiscal" },
            {
                title: "Estado",
                key: "estado",
                render: (_, row) =>
                    row.yaExiste ? <Tag color="orange">Ya existe</Tag> : <Tag color="green">Nuevo</Tag>,
            },
        ];
        return <Table size="small" rowKey="key" dataSource={this.state.clientes} columns={columns} pagination={false} />;
    }

    renderTablaProveedores() {
        const columns = [
            {
                title: "Importar",
                key: "seleccionado",
                width: 90,
                render: (_, row) => (
                    <Checkbox
                        checked={row.seleccionado}
                        disabled={row.yaExiste}
                        onChange={() => this.toggleSeleccion("proveedores", row.key)}
                    />
                ),
            },
            { title: "RFC", dataIndex: "rfc", key: "rfc" },
            { title: "Nombre / Razón Social", dataIndex: "nombre", key: "nombre" },
            { title: "Régimen Fiscal", dataIndex: "regimenFiscal", key: "regimenFiscal" },
            {
                title: "Estado",
                key: "estado",
                render: (_, row) =>
                    row.yaExiste ? <Tag color="orange">Ya existe</Tag> : <Tag color="green">Nuevo</Tag>,
            },
        ];
        return <Table size="small" rowKey="key" dataSource={this.state.proveedores} columns={columns} pagination={false} />;
    }

    renderTablaInsumos() {
        const { familias, unidades } = this.state.catalogosInsumos;
        const columns = [
            {
                title: "Importar",
                key: "seleccionado",
                width: 90,
                render: (_, row) => (
                    <Checkbox
                        checked={row.seleccionado}
                        disabled={row.yaExiste}
                        onChange={() => this.toggleSeleccion("insumos", row.key)}
                    />
                ),
            },
            { title: "Clave", dataIndex: "clave", key: "clave" },
            { title: "Descripción", dataIndex: "descripcion", key: "descripcion" },
            {
                title: "Costo",
                key: "costo",
                width: 120,
                render: (_, row) => (
                    <InputNumber
                        style={{ width: "100%" }}
                        value={row.costo}
                        min={0}
                        onChange={(valor) => this.actualizarCampoInsumo(row.key, "costo", valor)}
                    />
                ),
            },
            {
                title: "Unidad",
                key: "unidadId",
                width: 160,
                render: (_, row) => (
                    <Select
                        style={{ width: "100%" }}
                        placeholder={row.unidad || "Elegir"}
                        value={row.unidadId || undefined}
                        onChange={(valor) => this.actualizarCampoInsumo(row.key, "unidadId", valor)}
                    >
                        {(unidades || []).map((u) => (
                            <Option key={u._id} value={u._id}>{u.nombre}</Option>
                        ))}
                    </Select>
                ),
            },
            {
                title: "Familia",
                key: "familiaId",
                width: 160,
                render: (_, row) => (
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Elegir"
                        value={row.familiaId}
                        onChange={(valor) => this.actualizarCampoInsumo(row.key, "familiaId", valor)}
                    >
                        {(familias || []).map((f) => (
                            <Option key={f._id} value={f._id}>{f.nombre}</Option>
                        ))}
                    </Select>
                ),
            },
            {
                title: "Inventariable",
                key: "inventariable",
                width: 100,
                render: (_, row) => (
                    <Switch
                        checked={row.inventariable}
                        onChange={(valor) => this.actualizarCampoInsumo(row.key, "inventariable", valor)}
                    />
                ),
            },
            {
                title: "Estado",
                key: "estado",
                render: (_, row) =>
                    row.yaExiste ? <Tag color="orange">Ya existe</Tag> : <Tag color="green">Nuevo</Tag>,
            },
        ];
        return <Table size="small" rowKey="key" dataSource={this.state.insumos} columns={columns} pagination={false} />;
    }

    render() {
        const emision = this.state.tipo === "emision";
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Importar desde SAT"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background" style={{ paddingTop: 5 }}>
                    <Spin spinning={this.state.loading}>
                        <Form ref={this.formRef} name="importarSatEntidades" layout onFinishFailed={this.onFinishFailed}>
                            <Row style={{ marginTop: 20 }}>
                                <Col span={24} xs={24} sm={24} md={12} lg={12}>
                                    <FormItem name="empresaId" label="Empresa" required>
                                        <SelectEmpresasBiwoItem
                                            placeholder="Seleccionar empresa"
                                            onChange={this.onChangeEmpresa.bind(this)}
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={24} xs={24} sm={24} md={12} lg={12}>
                                    <FormItem label="Tipo">
                                        <Radio.Group value={this.state.tipo} onChange={this.onChangeTipo.bind(this)}>
                                            <Radio.Button value="emision">Emisión (Clientes + Insumos)</Radio.Button>
                                            <Radio.Button value="recepcion">Recepción (Proveedores)</Radio.Button>
                                        </Radio.Group>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem label="Origen del ZIP">
                                        <Radio.Group value={this.state.origenZip} onChange={this.onChangeOrigenZip.bind(this)}>
                                            <Radio.Button value="subir">Subir ZIP nuevo</Radio.Button>
                                            <Radio.Button value="existente">Usar uno ya descargado</Radio.Button>
                                        </Radio.Group>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} xs={24} sm={24} md={12} lg={12}>
                                    {this.state.origenZip === "subir" ? (
                                        <FormItem label="Archivo ZIP">
                                            <Upload
                                                showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                                                fileList={this.state.archivoZip}
                                                customRequest={({ file, onSuccess }) => { this.onChangeZip(file); onSuccess("ok"); }}
                                                accept=".zip"
                                                maxCount={1}
                                            >
                                                <ButtonItem icon={<FileZipOutlined />}>Subir ZIP</ButtonItem>
                                            </Upload>
                                        </FormItem>
                                    ) : (
                                        <FormItem label={`ZIP ya descargado (${emision ? "Emisión" : "Recepción"})`}>
                                            <SeleccionarZipDescargaSat
                                                empresaId={this.state.empresaId}
                                                emision={emision}
                                                headersToken={this.props.headersToken}
                                                value={this.state.zipExistenteRef}
                                                onChange={(value) => this.setState({ zipExistenteRef: value })}
                                            />
                                        </FormItem>
                                    )}
                                </Col>
                                <Col span={24} xs={24} sm={24} md={12} lg={12} style={{ display: "flex", alignItems: "flex-end", paddingBottom: 24 }}>
                                    <ButtonItem type="primary" icon={<UploadOutlined />} onClick={this.leerXml.bind(this)}>
                                        Leer XML
                                    </ButtonItem>
                                </Col>
                            </Row>
                        </Form>

                        {this.state.leido && (
                            <>
                                <Divider />
                                <Alert
                                    style={{ marginBottom: 10 }}
                                    type="info"
                                    showIcon
                                    message="Revisa las filas propuestas: los ya existentes en el catálogo aparecen desmarcados y no se pueden reimportar."
                                />
                                {emision ? (
                                    <>
                                        <h4>Clientes propuestos</h4>
                                        {this.renderTablaClientes()}
                                        <h4 style={{ marginTop: 20 }}>Insumos propuestos</h4>
                                        {this.renderTablaInsumos()}
                                    </>
                                ) : (
                                    <>
                                        <h4>Proveedores propuestos</h4>
                                        {this.renderTablaProveedores()}
                                    </>
                                )}
                                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                                    <ButtonItem type="primary" onClick={this.importarSeleccionados.bind(this)}>
                                        Importar seleccionados
                                    </ButtonItem>
                                </div>
                            </>
                        )}
                    </Spin>
                </div>
                <ModalProgreso
                    visible={this.state.importandoInsumos}
                    titulo="Importando insumos"
                    descripcion="No cierres esta ventana: el proceso sigue en el servidor, pero perderías el avance en pantalla. Los insumos se crean por lotes para no saturar la base."
                    procesados={this.state.progreso.procesados}
                    total={this.state.progreso.total}
                    unidad="insumos"
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(ImportarSatEntidades);
